import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;
declare var jQuery: any;

@Component({
  standalone: false,
  selector: 'app-edit-therapist',
  templateUrl: './edit-therapist.component.html',
  styleUrls: ['./edit-therapist.component.css']
})
export class EditTherapistComponent implements OnInit {

  addTherapistForm: FormGroup | any;
  file: any;
  imageType: any;
  imageUrl: any;
  countryArr: any = [];
  selectedTherapy: any;
  week: any = [];
  programList: any = [];
  today: string = "";
  userId: any;
  viewTherapist: any;
  eventChecked: boolean = false;
  weekIndex: number = 0;
  Sunday = {
    week: 'Sunday',
    checked: false
  };
  Monday = {
    week: 'Monday',
    checked: false
  };
  Tuesday = {
    week: 'Tuesday',
    checked: false
  };
  Wednesday = {
    week: 'Wednesday',
    checked: false
  };
  Thursday = {
    week: 'Thursday',
    checked: false
  };
  Friday = {
    week: 'Friday',
    checked: false
  };
  Saturday = {
    week: 'Saturday',
    checked: false
  };
  selectedWeekStatus: any = [];
  editScheduleForm: FormGroup | any;
  assignedProgram: any = [];
  constructor(public service: MainService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.activatedRoute.params.subscribe((res) => {
      this.userId = res.id
    })
  }

  ngOnInit() {
    this.addTherapistFormValidation();
    this.editScheduleFormValidation();
    this.getCountryCodeData();
    this.viewProgramList();
    this.viewTherapistApi();

    jQuery.fn.multiselect = function () {
      var $that = $(this);
      $that.each(function () {
        var checkboxes = $that.find("input:checkbox");
        checkboxes.each(function () {
          var checkbox = $that;
          // Highlight pre-selected checkboxes
          if (checkbox.prop("checked"))
            checkbox.parent().addClass("multiselect-on");
          // Highlight checkboxes that the user selects
          checkbox.click(function () {
            if (checkbox.prop("checked"))
              checkbox.parent().addClass("multiselect-on");
            else
              checkbox.parent().removeClass("multiselect-on");
          });
        });
      });
    };
    $(() => {
      $(".multiselect").multiselect();
    })


  }

  programChange(event: any, id: any) {
    if (event === true) {
      this.assignedProgram.push(id);
    }
    else {
      if ((event === false) && this.assignedProgram.length > 0) {
        let index = this.assignedProgram.findIndex((x: any) => x == id)
        this.assignedProgram.splice(index, 1);
      }
    }

  }

  // Add Subadmin Form Validation

  addTherapistFormValidation() {
    this.addTherapistForm = new FormGroup({
      //  'programId' : new FormControl('',Validators.required),
      'address': new FormControl('', Validators.required),
      'timeZone': new FormControl('0', Validators.required),
      'speciality': new FormControl('ENGLISH', Validators.required),
      'degree': new FormControl('', Validators.required),
      'conPassword': new FormControl(''),
      'password': new FormControl(''),

      'institution': new FormControl('', Validators.required),
      'phoneCode': new FormControl('+1', Validators.required),

      'firstName': new FormControl('', Validators.compose([Validators.required, Validators.maxLength(62), Validators.pattern(/^[^\s][a-zA-Z ]*$/)])),
      'lastName': new FormControl(''),
      "email": new FormControl('', ([Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/i), Validators.maxLength(50)])),
      "phoneNumber": new FormControl('', ([Validators.required, Validators.pattern(/^[1-9][0-9]{9,13}$/)])),
    });
    this.addTherapistForm.valueChanges.subscribe();
  }

  // schedule form validation
  editScheduleFormValidation() {
    this.editScheduleForm = new FormGroup({
      'startDate': new FormControl('', Validators.required),
      'endDate': new FormControl('', Validators.required),
      'interval': new FormControl('', Validators.required),
      'startHourTime': new FormControl('', Validators.required),
      'endHourTime': new FormControl('', Validators.required),
    })
  }

  // program list api inntegration 
  viewProgramList() {
    this.service.getApi(ApiUrls.programList, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.programList = res.result;
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  // program list api inntegration 
  viewTherapistApi() {
    this.service.showSpinner();
    this.service.getApi(`${ApiUrls.viewTherapist}?userId=${this.userId}`, 1).subscribe((res) => {
      if (res.responseCode == 200) {
        this.service.hideSpinner();
        this.viewTherapist = res.result;
        this.viewTherapist.assignedPrograms.forEach((ids: any) => {
          this.assignedProgram.push(ids._id)
        });
        this.programList.forEach((prId: any) => {
          this.viewTherapist.assignedPrograms.forEach((res: any) => {
            if (prId._id == res._id) {
              prId['checked'] = true;
            }

          })
        });
        this.selectedTherapy = this.viewTherapist.role;
        this.imageUrl = this.viewTherapist.profilePic;


        this.addTherapistForm.patchValue({
          // 'programId' : this.viewTherapist.programId,
          'address': this.viewTherapist.address,
          'timeZone': this.viewTherapist.offSet,
          'speciality': this.viewTherapist.speciality,
          'degree': this.viewTherapist.degree,
          // 'interval' : this.viewTherapist.password,
          'institution': this.viewTherapist.institution,
          'phoneCode': this.viewTherapist.countryCode,
          // 'startDate' : this.viewTherapist,
          'firstName': this.viewTherapist.firstName,
          'lastName': this.viewTherapist.lastName,
          "email": this.viewTherapist.email,
          "phoneNumber": this.viewTherapist.mobileNumber,
        })
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.errorToast(err.responseMessage)
    })
  }

  // edit therapist api integration 
  editTherapist() {
    if (this.assignedProgram.length == 0) {
      this.service.errorToast('Please select program');
      return
    }
    let data: any = {
      assignedPrograms: this.assignedProgram,
      role: this.selectedTherapy,
      firstName: this.addTherapistForm.value.firstName,
      lastName: this.addTherapistForm.value.lastName,
      email: this.addTherapistForm.value.email,
      countryCode: this.addTherapistForm.value.phoneCode,
      mobileNumber: this.addTherapistForm.value.phoneNumber,
      profilePic: this.imageUrl,
      speciality: this.addTherapistForm.value.speciality,
      degree: this.addTherapistForm.value.degree,
      institution: this.addTherapistForm.value.institution,
      offSet: this.addTherapistForm.value.timeZone,
      address: this.addTherapistForm.value.address
    }
    if (this.addTherapistForm.value.password.length > 0) {
      data['password'] = this.addTherapistForm.value.password;
    }
    this.service.showSpinner()
    this.service.putApi(ApiUrls.editTherapist + `?userId=${this.userId}`, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage);
        this.router.navigate(['therapist'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  setSlotApi() {
    if (this.editScheduleForm.value.startDate > this.editScheduleForm.value.endDate) {
      this.service.errorToast('Start Date should be less than end Date');
      return
    }
    if (this.editScheduleForm.value.startHourTime.split(':')[0] > this.editScheduleForm.value.endHourTime.split(':')[0]) {
      this.service.errorToast('Start time should be less than end time');
      return
    }

    if (this.week.length == 0) {
      this.service.errorToast('Please select week days');
      return
    }
    const data = {
      userId: this.userId,
      startDate: this.editScheduleForm.value.startDate,
      endDate: this.editScheduleForm.value.endDate,
      weekDays: this.week,
      interval: Number(this.editScheduleForm.value.interval),
      startHour: this.editScheduleForm.value.startHourTime.split(':')[0],
      startMinute: this.editScheduleForm.value.startHourTime.split(':')[1],
      endHour: this.editScheduleForm.value.endHourTime.split(':')[0],
      endMinute: this.editScheduleForm.value.endHourTime.split(':')[1],
    };
    this.service.showSpinner();
    this.service.postApi(ApiUrls.setSlot, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast(res.responseMessage);
        this.router.navigate(['therapist'])
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    })
  }

  ValidateFileUpload(event: any) {
    this.file = event.target.files;
    if (this.file[0]) {
      this.imageType = this.file[0].type;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageUrl = e.target.result;
        this.uploadImage()
      };
      reader.readAsDataURL(this.file[0]);
    }
  }

  weekChange(event: any, week: any) {
    if (event === true) {
      this.week.push(week);
      this.selectedWeekStatus.push({ "week": week, "checked": event });
    }
    else {
      if ((event === false) && this.week.length > 0) {
        this.weekIndex = this.week.findIndex((x: any) => x == week)
        this.week.splice(this.weekIndex, 1);
        this.selectedWeekStatus.splice(this.weekIndex, 1);
      }
    }
    this.eventChecked = event;
    let Sunday = this.selectedWeekStatus.find((x: any) => (x.week == 'Sunday') && (x.checked == true));
    if (Sunday == undefined) {
      this.Sunday = {
        week: 'Sunday',
        checked: false
      };
    }
    else {
      this.Sunday = Sunday
    }
    let Monday = this.selectedWeekStatus.find((x: any) => (x.week == 'Monday') && (x.checked == true));
    if (Monday == undefined) {
      this.Monday = {
        week: 'Monday',
        checked: false
      };
    }
    else {
      this.Monday = Monday
    }
    let Tuesday = this.selectedWeekStatus.find((x: any) => (x.week == 'Tuesday') && (x.checked == true));
    if (Tuesday == undefined) {
      this.Tuesday = {
        week: 'Tuesday',
        checked: false
      };
    } else {
      this.Tuesday = Tuesday
    }
    let Wednesday = this.selectedWeekStatus.find((x: any) => (x.week == 'Wednesday') && (x.checked == true));
    if (Wednesday == undefined) {
      this.Wednesday = {
        week: 'Wednesday',
        checked: false
      };
    } else {
      this.Wednesday = Wednesday
    }
    let Thursday = this.selectedWeekStatus.find((x: any) => (x.week == 'Thursday') && (x.checked == true));
    if (Thursday == undefined) {
      this.Thursday = {
        week: 'Thursday',
        checked: false
      };
    } else {
      this.Thursday = Thursday
    }
    let Friday = this.selectedWeekStatus.find((x: any) => (x.week == 'Friday') && (x.checked == true));
    if (Friday == undefined) {
      this.Friday = {
        week: 'Friday',
        checked: false
      };
    } else {
      this.Friday = Friday
    }

    let Saturday = this.selectedWeekStatus.find((x: any) => (x.week == 'Saturday') && (x.checked == true));
    if (Saturday == undefined) {
      this.Saturday = {
        week: 'Saturday',
        checked: false
      };
    } else {
      this.Saturday = Saturday
    }
  }


  // upload Image APi Integration 
  uploadImage() {
    const data: FormData = new FormData();
    data.append('image', this.file[0])
    this.service.postApi(ApiUrls.uploadImage, data, 3).subscribe((res) => {
      if (res.responseCode == 200) {
        this.imageUrl = res.result.image
      }
    })
  }

  // Block special character from name
  inputkeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
    }
  }
  //Allow only numbers
  inputKeyPress(e: any) {
    var k
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
    else {
      document.all ? k = e.keyCode : k = e.which;
      return ((k > 47 && k < 58) || k == 8);
    }
  }

  //For password keypres
  passwordKeyPress(e: any) {
    if (e.charCode == 32 && !e.target.value) {
      e.preventDefault()
    }
  }

  getCountryCodeData() {
    this.service.getCountryCode().subscribe((res) => {
      this.countryArr = res
    })
  }

  onImageError(event: any) {
    event.target.src = 'https://res.cloudinary.com/smsit/image/upload/v1597335652/fmcvdi2g6ogd5vwzvzfa.jpg';
  }
}
